import { createFileRoute, redirect } from '@tanstack/react-router'

import { isEmptySearch, rememberSearch, rememberedSearch } from '@/features/market/last-search'
import { MarketScreen } from '@/features/market/market-screen'
import { marketSearchSchema } from '@/features/market/market-search'

/**
 * Every listing the platform has seen, searched and filtered from the address. Opened with no
 * search (the rail, a way back), it opens on the last search this browser kept; any search it is
 * opened on becomes the last.
 */
export const Route = createFileRoute('/_app/platform/market/')({
  validateSearch: (search) => marketSearchSchema.parse(search),
  beforeLoad: ({ search }) => {
    if (!isEmptySearch(search)) {
      rememberSearch(search)
      return
    }
    const last = rememberedSearch()
    if (last !== undefined) throw redirect({ to: '/platform/market', search: last, replace: true })
  },
  component: MarketScreen,
})
